// @flow
import styled from 'styled-components';
import { EASE_IN_OUT_25 } from 'styles/transitions';

const BusinessLogo = styled.img`
  ${EASE_IN_OUT_25};
  width: 80px;
`;

export default BusinessLogo;



// WEBPACK FOOTER //
// ./src/components/payer/business-logo/index.js